import { Component, OnInit, Inject, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Form, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from '../../../../../services/form.service';
import { Subject, of, concat, Observable, BehaviorSubject } from 'rxjs';
import { RecordService } from '../../../../../services/record.service';
import { Select } from '../../../../../objects/select';
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  finalize,
  filter,
  first,
} from 'rxjs/operators';
import { NotificationService } from '../../../../../services/notification.service';
import { CustomTranslateService } from '../../../../../services/custom-translate.service';
import { ArrService } from '../../../../../services/helpers/arr.service';
import { ListingService } from '../../../../../services/listing.service';
import { RelateIds } from '../../../../../lists/relate-ids';
import * as _moment from 'moment';
import { StatusCode } from '../../../../../lists/status-code';
import { RecurringJobLineItem } from '../../../../../objects/recurring-job-line-item';
const moment = (_moment as any).default ? (_moment as any).default : _moment;
import { WorkOrderItemsComponent } from '../../../view/jobs/work-order-items/work-order-items.component';
import { isValidWorkOrderLines, OnWorkOrderLinesUpdate, WorkOrderDefaultPricebook, WorkOrderItemsComponentConfig, WorkOrderLine, WorkOrderLineData } from '../../../view/jobs/work-order-items/work-order-items.component';
import { get, isEmpty, isNil, trim, map as _map, first as _first } from 'lodash-es';
import { LooseObject } from '../../../../../objects/loose-object';
import { ClientStoreService } from '../../../../../services/client-store.service';
import { Router } from '@angular/router';
import { MaterialLineData, OnMaterialsUpdate } from '../../../../../module/jobs/materials/log-materials/components/material-lines/material-lines.component';
import { blank, data_get, data_is_false, fallback, filled, isIn, transform, whenFilled, is_value_true } from '../../../../utils/common';
import { MaterialLineItem } from '../../../../../module/jobs/materials/log-materials/material-line-item';
import { TaxCode } from '../../../../../objects/tax-code';
import { AssetItems } from '../../../../../objects/assets-item';
import { Department } from '../../../../../objects/department';

@Component({
  selector: 'app-edit-recurring-jobs',
  templateUrl: './edit-recurring-jobs.component.html',
  styleUrls: ['./edit-recurring-jobs.component.scss']
})
export class EditRecurringJobsComponent implements OnInit {
  public recurringJobForm: any = [];
  public strRecordId: string = (this.data.record_id != undefined && this.data.record_id != null && this.data.record_id != '') ? this.data.record_id : null;
  public strViewType: string = this.data.view_type;
  public strRecordModule: string = this.data.module;
  public arPeriodOptions: any = this.data.period_options;
  public bSubmitted: boolean = false;
  public bShowErrors: boolean = false;
  public hasError: boolean = false;

  public relateAssetGroupData: any = [];
  public relateChecklistData: any = [];
  public relateRequiredSkillData: any = [];
  public bHasAssetType: boolean = false;
  public bHasChanged: boolean = false;
  public arCustomColumn = [];
  public strAssetGroupId: any = [];
  public strChecklistId: any = [];
  public strRequiredSkillId: any = [];
  public arRecurringJobsData: any = [];
  public arRelatedData: [] = [];
  public arReadOnlyId: any = [];
  public arRelateEmptyId: any = [];
  public arRequiredField: any = [];

  public strAssetTypeId: string = null;
  public arLineAttributes: object[] = [];
  public objChecklistFilter: {} = {};
  public objModuleConfig: {} = {};
  public currentInvoicing: {} = {};
  public isBillableOn: boolean;

  public objRecurringJobRecord: object = {};

  public objWorkOrder: any = [];

  @HostListener('window:keyup.esc') onKeyUp() {
    this.cancelDialog();
  }

  @HostListener('window:resize', ['$event']) sizeChange(event) {
    this.setDialogStyle();
  }

  /**
   * Observable to emit when disabling the submit button
   *
   * @type {BehaviorSubject<boolean>}
   */
  disabledSaveButton$ = new BehaviorSubject(false);

  /**
   * If department tracking is enabled.
   *
   * @var {boolean}
   */
  public bDepartmentTracking: boolean = false;

  public arToggleJobTask = [];

  readonly workOrderComponentConfig$ = new BehaviorSubject<WorkOrderItemsComponentConfig|null>(null);

  readonly initialMaterials$ = new BehaviorSubject<MaterialLineData[]>([]);

  readonly initialWorkOrder$ = new BehaviorSubject<WorkOrderLineData[]>([]);

  readonly wasValidated$ = new BehaviorSubject<boolean>(false);

  readonly defaultTaxCode$ = new BehaviorSubject<TaxCode|null>(null);

  readonly defaultDepartment$ = new BehaviorSubject<Department|null>(null);

  readonly defaultPricebook$ = new BehaviorSubject<WorkOrderDefaultPricebook|null>(null);

  _workOrderLines: WorkOrderLine[] = [];

  _materialLines: MaterialLineItem[] = [];

  _pricebokId: string;

  constructor(
    public dialogRef: MatDialogRef<EditRecurringJobsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public formService: FormService,
    public recordService: RecordService,
    public notifService: NotificationService,
    public customTranslate: CustomTranslateService,
    public arrService: ArrService,
    public elemRef: ElementRef,
    public listingService: ListingService,
    private renderer: Renderer2,
    private client: ClientStoreService,
    private router: Router
  ) { }

  ngOnInit() {

    this.bDepartmentTracking = this.client.isDepartmentTracking();

    if (this.data['recurring_job_id'] != undefined && this.data['recurring_job_id'] != '' && this.data['recurring_job_id'] != null) {
        this.recordService.getRecord('recurring_jobs', this.data['recurring_job_id'], true, {}, 'edit_form').subscribe( response => {
          this.objRecurringJobRecord = response;
          // Get updated record data of currently updating.
          this.data['recurring_job'] = (response['record_details'] != null && Object.keys(response['record_details']).length > 0) ? response['record_details'] : [];
          this.arRelatedData = response['related_data'];
          this.objModuleConfig['record_details'] = response['record_details'];
          this.objModuleConfig['record_view'] = response['record_view'];
          this.objModuleConfig['used_fields'] = response['used_fields'];
          this.defaultTaxCode$.next(get(response, 'related_data.default_tax_code_sale'));
          this.defaultDepartment$.next(get(response, 'related_data.default_department'));
          this.defaultPricebook$.next(transform(get(response, 'record_details.pricebook_id'), {
            transformer: (id) => ({
              id: id,
              text: get(response, 'record_details.pricebook_text'),
            })
          }));

          this.setRecurringJob();

          // if (filled(this.objModuleConfig['record_details']['site_id'])) {
          //   this.onChangeField({type: 'site_id', data: { id: this.objModuleConfig['record_details']['site_id'] }}) ;
          // }
          console.log()
        });
    } else {
      this.recordService.getRecordConfig('recurring_jobs', null, true).pipe(
        first(),
      ).subscribe( response => {
        this.objRecurringJobRecord = response;
        this.arRelatedData = response['related_data'];
        this.objModuleConfig = response;
        this.defaultTaxCode$.next(get(response, 'related_data.default_tax_code_sale'));
        this.defaultDepartment$.next(get(response, 'related_data.default_department'));
        this.setRecurringJob();
      });
    }

    if (this.data['from_convert_jobs']) {
      this.convertFromJobs();
      this.currentInvoicing = {id: this.data['invoicing_type']};
      this.isBillableOn = this.data['billable'];
    } else if (this.strViewType === 'edit' && filled(this.data['recurring_job'])) {
      this.currentInvoicing = {id: this.data['recurring_job']['invoicing_type']};
      this.isBillableOn = this.data['recurring_job']['billable'];
    } else {
      this.isBillableOn = true;
      this.currentInvoicing = {id: 'time_and_materials'};
    }

    this.updateBillingTabDisplay();
    this.dialogRef.backdropClick().subscribe(_ => {
      this.cancelDialog();
    });
    this.setDialogStyle();
  }

  /**
   * Set recurring job form
   */
  setRecurringJob() {
    const strActionType = get(this.data, 'action');
    if (filled(this.data.objDefault) && strActionType === 'duplicate') {
      this.data.recurring_job = this.data.objDefault;
    }

    if (this.strViewType === 'edit' || strActionType == 'duplicate') {
      this.strAssetTypeId = this.data['recurring_job']['asset_type_id'];
      this.objChecklistFilter = this.strAssetTypeId ? {'checklists.asset_type_id': this.strAssetTypeId, 'is_checklist_enabled': true} : null;
      this.isBillableOn = this.data['recurring_job']['billable'];

      this.initField();

      this.recurringJobForm.map( form => {
        let objField = Object.keys(form['groups']['controls']);
        objField.forEach( strField => {
          let indexField = this.getFieldIndex(strField, form);
          if (indexField > -1) {
            if (form['fields'][indexField]['controlType'] == 'relate') {
              let textField = strField.replace('_id', '_text');
              let strText = this.data['recurring_job'][textField];
              form['fields'][indexField]['default_value'] = this.data['recurring_job'][strField];
              form['fields'][indexField]['default_text'] = strText;
            }
            // If mode is edit. Set job field as readonly. due to unable to change the job when created
            if (strField == 'job_id') {
              form['fields'][indexField]['readonly'] = true;
            }

            if (strField === 'amount' && this.data['recurring_job']['billable'] === false) {
              form['fields'][indexField]['is_hidden'] = true;
            }

            if (strField === 'invoicing_type' && data_is_false(data_get(this.data, 'recurring_job.billable'))) {
              form['fields'][indexField]['is_hidden'] = true;
            }
          }
          // If field exist. Set field value
          if (this.data['recurring_job'][strField] != undefined) {
            this.fieldPatchValue(strField, this.data['recurring_job'][strField]);
          }
        });
      });

      if (this.arrService.keyFallsBackTo(this.data['recurring_job'], 'assets_items', null) !== null && this.data['recurring_job']['assets_items'].length > 0) {
        this.data['recurring_job']['assets_items'].forEach( assets_item => {
          this.addAssetAttribute(assets_item);
        });
      } else {
        this.addAssetAttribute();
      }

      if (filled(get(this.data, 'recurring_job.work_order_items', []))) {
        this.initialWorkOrder$.next(_map(
          get(this.data, 'recurring_job.work_order_items', []),
          (line) => ({
            labor: get(line, 'labor', false),
            unit_cost: get(line, 'unit_cost', 0),
            hourly_cost: get(line, 'hourly_cost', 0),
            work_order_reference: get(line, 'work_order_reference'),
            unit_price: get(line, 'unit_price', 0),
            discounted_price: get(line, 'discounted_price', 0),
            description: get(line, 'description'),
            is_created: get(line, 'is_created', false),
            item_id: get(line, 'item_id'),
            item_name: get(line, 'item_name'),
            item_code: get(line, 'item_code'),
            line_item: get(line, 'line_item', 0),
            markup: get(line, 'markup', 0),
            quantity: get(line, 'quantity', 0),
            tax_code: get(line, 'tax_code'),
            tax_rate: get(line, 'tax_rate', 0),
            tax_code_id: get(line, 'tax_code_id'),
            tax_code_name: get(line, 'tax_code_name'),
            current_stock_level: get(line, 'current_stock_level', 0),
            related_products: get(line, 'related_products', []),
            supplier_pricing: get(line, 'supplier_pricing', []),
            department_id: get(line, 'department_id', null),
            department_name: get(line, 'department_name', null),
          })
        ));
      }

      if (filled(get(this.data, 'recurring_job.material_line_items', []))) {
        this.initialMaterials$.next(_map(
          get(this.data, 'recurring_job.material_line_items', []),
          (line) => ({
            id: get(line, 'id'),
            quantity: get(line, 'quantity', 0),
            item_id: get(line, 'item_id'),
            item_name: get(first(get(line, 'item')), 'name'),
            item_code: get(first(get(line, 'item')), 'code'),
            work_order_reference: get(line, 'work_order_reference'),
            once_off_product_name: get(line, 'product'),
            unit_price: get(line, 'unit_price'),
            unit_cost: get(line, 'unit_cost'),
            markup: get(line, 'markup'),
            notes: get(line, 'notes'),
            supplier_pricing: get(line, 'supplier_pricing', []),
            related_products: get(line, 'related_products', []),
          })
        ));
      }

      if (filled(this.data['billable'])) {
        this._toggleInvoicingTypeDisplay(this.data['billable']);
      }

      if (filled(this.data['next_job_date'])) {
        let nextJobDateIndex = this.getFormFieldIndex('next_job_date');
        let nextJobDateIndexField = this.getFieldIndex('next_job_date', this.recurringJobForm[nextJobDateIndex]);
        this.recurringJobForm[nextJobDateIndex]['fields'][nextJobDateIndexField]['default_value'] = this.data['next_job_date'];
        this.fieldPatchValue('next_job_date', this.data['next_job_date']);
      }

      if (filled(data_get(this.data, 'assigned_user.id')) && filled(data_get(this.data, 'assigned_user.name'))) {
        let userFormIndex = this.getFormFieldIndex('user_id');
        let userFormIndexField = this.getFieldIndex('user_id', this.recurringJobForm[userFormIndex]);
        this.recurringJobForm[userFormIndex]['fields'][userFormIndexField]['default_value'] = this.data['assigned_user']['id'];
        this.recurringJobForm[userFormIndex]['fields'][userFormIndexField]['default_text'] = this.data['assigned_user']['name'];
        this.fieldPatchValue('user_id', this.data['assigned_user']['id']);

      }

      this.setInvoicingTypeValid();
      this._listenToChanges();
    } else if (this.data['from_convert_jobs']) {
      this.strAssetTypeId = this.data['asset_type_id'];
      this.objChecklistFilter = this.strAssetTypeId ? {'checklists.asset_type_id': this.strAssetTypeId, 'is_checklist_enabled': true} : null;
      this.isBillableOn = this.data['billable'];

      this.initField();

      this.recurringJobForm.map( form => {
        let objField = Object.keys(form['groups']['controls']);
        objField.forEach( strField => {
          let indexField = this.getFieldIndex(strField, form);
          if (indexField > -1) {
            if (form['fields'][indexField]['controlType'] == 'relate') {
              let textField = strField.replace('_id', '_text');
              let strText = this.data[textField];
              form['fields'][indexField]['default_value'] = this.data[strField];
              form['fields'][indexField]['default_text'] = strText;
            }
            // If mode is edit. Set job field as readonly. due to unable to change the job when created
            if (strField == 'job_id') {
              form['fields'][indexField]['readonly'] = true;
            }

            if (strField === 'amount' && this.data['billable'] === false) {
              form['fields'][indexField]['is_hidden'] = true;
            }
          }
          // If field exist. Set field value
          if (filled(this.data[strField])) {
            this.fieldPatchValue(strField, this.data[strField]);
          }
        });
      });

      if (this.arrService.keyFallsBackTo(this.data, 'assets_items', null) !== null && this.data['assets_items'].length > 0) {
        this.data['assets_items'].forEach( assets_item => {
          this.addAssetAttribute(assets_item);
        });
      } else {
        this.addAssetAttribute();
      }

      if (filled(get(this.data, 'work_order_items', []))) {
        this.initialWorkOrder$.next(_map(
          get(this.data, 'work_order_items', []),
          (line) => ({
            labor: get(line, 'labor', false),
            unit_cost: get(line, 'unit_cost', 0),
            hourly_cost: get(line, 'hourly_cost', 0),
            work_order_reference: get(line, 'work_order_reference'),
            unit_price: get(line, 'unit_price', 0),
            discounted_price: get(line, 'discounted_price', 0),
            description: get(line, 'description'),
            is_created: get(line, 'is_created', false),
            item_id: get(line, 'item_id'),
            item_name: get(line, 'item_name'),
            item_code: get(line, 'item_code'),
            line_item: get(line, 'line_item'),
            markup: get(line, 'markup', 0),
            quantity: get(line, 'quantity', 0),
            tax_code: get(line, 'tax_code'),
            tax_rate: get(line, 'tax_rate', 0),
            tax_code_id: get(line, 'tax_code_id'),
            tax_code_name: get(line, 'tax_code_name'),
            current_stock_level: get(line, 'current_stock_level', 0),
            related_products: get(line, 'related_products', []),
            supplier_pricing: get(line, 'supplier_pricing', []),
            department_id: get(line, 'department_id', null),
            department_name: get(line, 'department_name', null),
          })
        ));
      }

      if (filled(get(this.data, 'material_line_items', []))) {
        this.initialMaterials$.next(_map(
          get(this.data, 'material_line_items', []),
          (line) => ({
            id: get(line, 'id'),
            quantity: get(line, 'quantity', 0),
            item_id: get(line, 'item_id'),
            item_name: get(first(get(line, 'item')), 'name'),
            item_code: get(first(get(line, 'item')), 'code'),
            work_order_reference: get(line, 'work_order_reference'),
            once_off_product_name: get(line, 'product'),
            unit_price: get(line, 'unit_price'),
            unit_cost: get(line, 'unit_cost'),
            markup: get(line, 'markup'),
            notes: get(line, 'notes'),
            supplier_pricing: get(line, 'supplier_pricing', []),
            related_products: get(line, 'related_products', []),
          })
        ));
      }

      this.setInvoicingTypeValid();
      this.convertFromJobs();
      this._listenToChanges();
    } else {
      this.recordService.getRecordBasedOnParent(!isNil(this.strRecordId) && this.router.url !== '/recurring_jobs').subscribe(response => {
        // FC-4062: if in list view (app.fieldmagic.co/#/recurring_jobs) and the 'Add' button is clicked, should not preselect a customer
        let arRecordData = response['record_details']
        let strCustomerId = null;
        let strSiteId = null;

        this.initField();

        let customerFormIndex = this.getFormFieldIndex('customer_id');
        let siteFormIndex = this.getFormFieldIndex('site_id');
        let customerIndexField = this.getFieldIndex('customer_id', this.recurringJobForm[customerFormIndex]);
        let siteIndexField = this.getFieldIndex('site_id', this.recurringJobForm[siteFormIndex]);

        if (this.data['customer_id'] && this.data['customer_text']) {
          arRecordData['customer_id'] = this.data['customer_id'];
          arRecordData['customer_text'] = this.data['customer_text'];
        }

        if (this.data['site_id'] && this.data['site_text']) {
          arRecordData['site_id'] = this.data['site_id'];
          arRecordData['site_text'] = this.data['site_text'];
        }

        if (arRecordData != undefined) {
          // Set Customer and Site id
          strCustomerId = (this.strRecordModule == 'customers') ? arRecordData['id'] : arRecordData['customer_id'];
          strSiteId = (this.strRecordModule == 'sites') ? arRecordData['id'] : (this.data['site_id'] ? this.data['site_id'] : null);
          this.recurringJobForm[customerFormIndex]['fields'][customerIndexField]['default_value'] = strCustomerId;
          this.recurringJobForm[customerFormIndex]['fields'][customerIndexField]['default_text'] = arRecordData['customer_text'];

          this.recurringJobForm[siteFormIndex]['fields'][siteIndexField]['default_value'] = strSiteId;
          this.recurringJobForm[siteFormIndex]['fields'][siteIndexField]['default_text'] = arRecordData['site_text'];
        }
        this.setInvoicingTypeValid();

        if (this.data['from_scheduler']) {
          let nextJobDateIndex = this.getFormFieldIndex('next_job_date');
          let nextJobDateIndexField = this.getFieldIndex('next_job_date', this.recurringJobForm[nextJobDateIndex]);
          let userFormIndex = this.getFormFieldIndex('user_id');
          let userFormIndexField = this.getFieldIndex('user_id', this.recurringJobForm[userFormIndex]);
          this.recurringJobForm[nextJobDateIndex]['fields'][nextJobDateIndexField]['default_value'] = this.data['next_job_date'];
          this.recurringJobForm[userFormIndex]['fields'][userFormIndexField]['default_value'] = this.data['user_id'];
          this.recurringJobForm[userFormIndex]['fields'][userFormIndexField]['default_text'] = this.data['user_text'];

          this.fieldPatchValue('next_job_date', this.data['next_job_date']);
          this.fieldPatchValue('user_id', this.data['user_id']);
        }

        this.fieldPatchValue('customer_id', strCustomerId);
        this.fieldPatchValue('site_id', strSiteId);
        this._listenToChanges();
        this.addAssetAttribute();
      });
    }
  }

  setInvoicingTypeValid() {
    let invoicingTypeIndex = this.getFormFieldIndex('invoicing_type');
    let invoicingTypeIndexField = this.getFieldIndex('invoicing_type', this.recurringJobForm[invoicingTypeIndex]);

    this.recurringJobForm[invoicingTypeIndex]['groups']['controls']['invoicing_type'].setValidators([Validators.required]);
    this.recurringJobForm[invoicingTypeIndex]['groups']['controls']['invoicing_type'].updateValueAndValidity();
    this.recurringJobForm[invoicingTypeIndex]['fields'][invoicingTypeIndexField]['required'] = true;
  }

  convertFromJobs() {
    this.fieldPatchValue('job_summary', this.data['job_summary']);
    this.fieldPatchValue('internal_notes', this.data['internal_notes']);
    this.fieldPatchValue('po_number', this.data['po_number']);
    this.fieldPatchValue('invoicing_type', this.data['invoicing_type']);
    this.fieldPatchValue('priority', this.data['priority']);
    this.fieldPatchValue('billable', this.data['billable']);

    if (filled(get(this.data, 'work_order_items', []))) {
      this.initialWorkOrder$.next(_map(
        get(this.data, 'work_order_items', []),
        (line) => ({
          labor: get(line, 'labor', false),
          unit_cost: get(line, 'unit_cost', 0),
          hourly_cost: get(line, 'hourly_cost', 0),
          work_order_reference: get(line, 'work_order_reference'),
          unit_price: get(line, 'unit_price', 0),
          discounted_price: get(line, 'discounted_price', 0),
          description: get(line, 'description'),
          is_created: get(line, 'is_created', false),
          item_id: get(line, 'item_id'),
          item_name: get(line, 'item_name'),
          item_code: get(line, 'item_code'),
          line_item: get(line, 'line_item', 0),
          markup: get(line, 'markup', 0),
          quantity: get(line, 'quantity', 0),
          tax_code: get(line, 'tax_code'),
          tax_rate: get(line, 'tax_rate', 0),
          tax_code_id: get(line, 'tax_code_id'),
          tax_code_name: get(line, 'tax_code_name'),
          current_stock_level: get(line, 'current_stock_level', 0),
          related_products: get(line, 'related_products', []),
          supplier_pricing: get(line, 'supplier_pricing', []),
          department_id: get(line, 'department_id', null),
          department_name: get(line, 'department_name', null)
        })
      ));
    }

    if (this.data['pricebook_id'] && this.data['pricebook_text']) {
      this.defaultPricebook$.next({
        id: get(this.data, 'pricebook_id'),
        text: get(this.data, 'pricebook_text'),
      });
    }
  }

  /**
   * On changes of form
   */
  private _listenToChanges(): void {
    let intIndexOfBillable: number = this.getFormFieldIndex('billable');
    let intIndexOfJobTemplateId: number = this.getFormFieldIndex('job_template_id');

    if (intIndexOfBillable > -1) {
      this.recurringJobForm[intIndexOfBillable]['groups'].get('billable').valueChanges.subscribe((value: boolean) => {
        this._toggleInvoicingTypeDisplay(value);
      });
    }

    if (intIndexOfJobTemplateId > -1) {
      this.recurringJobForm[intIndexOfJobTemplateId]['groups'].get('job_template_id').valueChanges.subscribe(strValue => {
        if (strValue) {
          this.recordService.getRecord('job_templates', strValue).subscribe(arResult => {
            const arValue = data_get(arResult, 'record_details', { default_value: {} });
            let arChecklists = data_get(arValue, 'checklists', { default_value: [] });

            arChecklists = arChecklists.filter(item => data_get(item, 'type') === 'job');

            if (is_value_true(data_get(arValue, 'billable', { default_value: false }))) {
              this.isBillableOn = true;
            } else {
              this.isBillableOn = false;
            }

            this._toggleInvoicingTypeDisplay(this.isBillableOn);

            const numInvoicingTypeFormIndex: number = this.getFormFieldIndex('invoicing_type');

            if (numInvoicingTypeFormIndex > -1) {
              const numInvoicingTypeIndexField: number = this.getFieldIndex('invoicing_type', data_get(this.recurringJobForm, numInvoicingTypeFormIndex));

              if (numInvoicingTypeIndexField > -1) {
                const arInvoicingTypeOptions = data_get(
                  this.recurringJobForm,
                  `${numInvoicingTypeFormIndex}.fields.${numInvoicingTypeIndexField}.options`,
                  { default_value: [] }
                );

                const strInvoicingType = data_get(arValue, 'invoicing_type');

                const existingInvoicingTypeOption = arInvoicingTypeOptions.find(data => filled(strInvoicingType) && data_get(data, 'id') === strInvoicingType)

                if (blank(existingInvoicingTypeOption)) {
                  arValue['invoicing_type'] = null;
                }
              }
            }

            this.fieldPatchValue('due_date', arValue['due_date']);
            this.fieldPatchValue('job_summary', arValue['job_summary']);
            this.fieldPatchValue('priority', arValue['priority']);
            this.fieldPatchValue('internal_notes', arValue['internal_notes']);
            this.fieldPatchValue('invoicing_type', arValue['invoicing_type']);
            this.fieldPatchValue('billable', arValue['billable']);
            this.fieldPatchValue('checklist_id', arChecklists);
            this.fieldPatchValue('skill_id', get(arValue, 'skill_id'));
            this.fieldPatchValue('resource_id', get(arValue, 'resource_id'));

            this.arLineAttributes = [];

            if (filled(get(arValue, 'material_line_items'))) {
              this.initialMaterials$.next(_map(
                get(arValue, 'material_line_items', []),
                (line) => ({
                  quantity: get(line, 'quantity', 0),
                  item_id: get(line, 'item_id'),
                  item_name: get(first(get(line, 'item')), 'name'),
                  item_code: get(first(get(line, 'item')), 'code'),
                  work_order_reference: get(line, 'work_order_reference'),
                  once_off_product_name: get(line, 'product'),
                  unit_price: get(line, 'unit_price'),
                  unit_cost: get(line, 'unit_cost'),
                  markup: get(line, 'markup'),
                  notes: get(line, 'notes'),
                })
              ));
            }

            if (filled(get(arValue, 'work_order_line_items'))) {
              this.initialWorkOrder$.next(_map(
                get(arValue, 'work_order_line_items', []),
                (line) => ({
                  labor: get(line, 'labor', false),
                  unit_cost: get(line, 'unit_cost', 0),
                  hourly_cost: get(line, 'hourly_cost', 0),
                  work_order_reference: get(line, 'work_order_reference'),
                  unit_price: get(line, 'unit_price', 0),
                  discounted_price: get(line, 'discounted_price', 0),
                  description: get(line, 'description'),
                  is_created: get(line, 'is_created', false),
                  item_id: get(line, 'item_id'),
                  item_name: get(line, 'item_name'),
                  item_code: get(line, 'item_code'),
                  line_item: get(line, 'line_item', 0),
                  markup: get(line, 'markup', 0),
                  quantity: get(line, 'quantity', 0),
                  tax_code: get(line, 'tax_code'),
                  tax_rate: get(line, 'tax_rate', 0),
                  tax_code_id: get(line, 'tax_code_id'),
                  tax_code_name: get(line, 'tax_code_name'),
                  current_stock_level: get(line, 'current_stock_level', 0),
                  related_products: get(line, 'related_products', []),
                  supplier_pricing: get(line, 'supplier_pricing', []),
                  department_id: get(line, 'department_id', []),
                  department_name: get(line, 'department_name', []),
                })
              ));
            }

            if (filled(get(arValue, 'pricebook_id'))) {
              this.defaultPricebook$.next({
                id: get(arValue, 'pricebook_id'),
                text: get(arValue, 'pricebook_text'),
              });
            }

            if (arValue['task_line_items'].length > 0) {
              arValue['task_line_items'].forEach(arLineItem => {
                this.addLineAttribute(arLineItem);
              });
            }
          });
        }
      });
    }
  }

  /**
   * Initialize form
   */
  initField() {

    // To set data of custom attributes as default value
    if (this.objModuleConfig['record_details']['custom_attributes'] != undefined && this.objModuleConfig['record_details']['custom_attributes'] != null && this.objModuleConfig['record_details']['custom_attributes'] != '') {
      let customAttributeKeys = Object.keys(this.objModuleConfig['record_details']['custom_attributes']);
      customAttributeKeys.forEach( strKey => {
        // Append each custom attributes to record details
        this.objModuleConfig['record_details'][strKey] = this.objModuleConfig['record_details']['custom_attributes'][strKey];
      });
    }

    let arFormData = this.formService.formData(this.objModuleConfig['record_view'], this.objModuleConfig['used_fields'], this.objModuleConfig['record_details']);

    this.recurringJobForm  = arFormData.map(
      formItems => {
        formItems['id'] = formItems['label'].toLowerCase().replace(/ /g,'_');
        formItems['groups'] = this.formService.toFormGroup(formItems['fields'])
        return formItems;
      }
    );
  }

  /**
   * Here we can manipulate the relate filter before requesting it to api
   *
   * @param relate_module
   * @param term
   * @param id
   * @param email
   * @param filter
   *
   * @retuns Observable<Select[]>
   */
  beforeInitRelateData(relateModule, term, id, email, filter): Observable<Select[]> {

    let strCustomerId = this.recurringJobForm.controls['customer_id'].value;
    filter = (filter) ? filter : {};
    if (relateModule === 'sites' && (term === null || term === '' ) && strCustomerId) {
      filter['customer_id'] = strCustomerId;
    }

    return this.recordService.getRecordRelate(relateModule, term, id, email, filter)
  }

  /**
   * Close the current dialog.
   */
  cancelDialog() {
    const isFormDirty = this.recurringJobForm.some(form => form.groups.dirty);

    if (isFormDirty) {
      // Pop-up modal for confirmation
      this.notifService.sendConfirmation('confirm_cancel')
        .pipe(
          filter(confirmation => confirmation.answer === true),
        )
        .subscribe(() => {
          this.dialogRef.close();
        });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Save Recurring job
   */
  saveRecurringJob() {
    this.bShowErrors = true;
    this.hasError = false;

    let objRecurringJobData = [];
    this.arReadOnlyId = [];
    this.arRelateEmptyId = [];
    this.arRequiredField = [];

    this.recurringJobForm.map(
      form => {
        Object.keys(form['groups'].value).forEach(
          item => {
            let strFieldMetadata = form['fields'].find( x => x.key == item);
            if (strFieldMetadata != undefined) {
              if (strFieldMetadata.readonly) this.arReadOnlyId.push(item);
              if (strFieldMetadata.controlType == 'relate') this.arRelateEmptyId.push(item);
              if (strFieldMetadata.required) this.arRequiredField.push(item);
            }
        })
    });

    //Loops the values.
    this.recurringJobForm.forEach(
      item => {
        //Merge all form group values into a single object.
        objRecurringJobData = {...objRecurringJobData, ...item['groups'].getRawValue()};
    });

    objRecurringJobData['billable'] = (objRecurringJobData['billable'] != '' && objRecurringJobData['billable'] != null && objRecurringJobData['billable'] != false) ? true : false;
    objRecurringJobData['status'] = (objRecurringJobData['status'] != '' && objRecurringJobData['status'] != null && objRecurringJobData['status'] != false) ? true : false;
    objRecurringJobData['automatically_create'] = (objRecurringJobData['automatically_create'] != '' && objRecurringJobData['automatically_create'] != null && objRecurringJobData['automatically_create'] != false) ? true : false;
    objRecurringJobData['amount'] = (objRecurringJobData['amount'] != '' && objRecurringJobData['amount'] != null) ? objRecurringJobData['amount'] : '0.00';

    if (this.strRecordId != null) {
      let strModuleId = RelateIds[this.strRecordModule];
      objRecurringJobData[strModuleId] = this.strRecordId;
    }

    if (objRecurringJobData['billable'] == false) {
      objRecurringJobData['amount'] = '0.00';
    }

    objRecurringJobData['expiry_date'] = (objRecurringJobData['expiry_date'] == undefined || objRecurringJobData['expiry_date'] == '' || objRecurringJobData['expiry_date'] == 'Invalid date') ? null : objRecurringJobData['expiry_date'];

    objRecurringJobData['pricebook_id'] = this._pricebokId;
    objRecurringJobData['work_order_items'] = _map(this._workOrderLines, (line) => ({
      ... line.encode(),
      tax_code: get(first(get(line, 'tax_code')), 'code'),
    }));

    this.validateRequest(objRecurringJobData);

    if (!this.hasError && this.isValidChecklistField()) {
      // FC-4660: Remove Job Tasks and Materials tab, and
      // Add Assets tab with asset type, checklists, price per asset,
      // time per asset, and asset tags, replacing the asset groups

      let filteredAssetAttributes = this.arLineAttributes.filter(arLineItem =>
        this.arrService.keyFallsBackTo(arLineItem['data'], 'asset_type_id', null) !== null ||
        this.arrService.keyFallsBackTo(arLineItem['data'], 'asset_tags_id', null) !== null ||
        this.arrService.keyFallsBackTo(arLineItem['data'], 'checklist_ids', null) !== null ||
        this.arrService.keyFallsBackTo(arLineItem['data'], 'department_id', null) !== null ||
        this.arrService.keyFallsBackTo(arLineItem['data'], 'price_per_asset', null) !== null ||
        this.arrService.keyFallsBackTo(arLineItem['data'], 'time_per_asset', null) !== null
      );

      let arAssets = [];

      filteredAssetAttributes.forEach(arLineItem => {
        arAssets.push(arLineItem['data']);
      });

      objRecurringJobData['assets_items'] = arAssets;


      this.processSave(objRecurringJobData);
    } else {
      this.notifService.notifyError('required_notice', {
        header: 'not_allowed',
      });
    }
  }

  /**
   * Process to create or update recurring job
   * @param objRecurringJobData
   */
  processSave(objRecurringJobData) {
    if (this.strViewType == 'edit' && this.data['recurring_job'] != undefined) {
      this.compareOldData(objRecurringJobData);

      if (this.bHasChanged) {
        // Save customer invoice
        this.recordService.saveRecord('recurring_jobs', objRecurringJobData, this.data['recurring_job']['id']).pipe(
          finalize(() => this.bSubmitted = false)
        ).subscribe(res => {
          if (res.status == 200) {
            this.dialogRef.close(res.body);
          } else if (res.status === StatusCode.kResponseAccepted) {
            this.notifService.promptError(res.body.error);
          } else {
            this.dialogRef.close('fail');
          }
        });
      } else {
        this.notifService.notifyWarning('no_changes_made', {
          header: 'not_allowed',
        });

        this.bSubmitted = false;
        this.dialogRef.close('fail');
      }

    } else {
      // Save customer invoice
      this.recordService.saveRecord('recurring_jobs', objRecurringJobData, '').pipe(
        finalize(() => this.bSubmitted = false)
      ).subscribe(res => {
        if (res.status === StatusCode.kResponseAccepted) {
          this.notifService.promptError(res.body.error);
        } else if (res.body.id != undefined) {
          // Show success notification for recurring job creation
          if (this.data.view_type === 'add') {
            this.notifService.notifySuccess('record_create_success');
          }

          this.dialogRef.close({
            status: 'save',
            data: res.body
          });
        }
      });
    }
  }

  /**
   * Compare the old data to the requested data
   * @param objRequestData - Requested data
   */
  compareOldData(objRequestData) {
    let objRequestFields = Object.keys(objRequestData);
    let arRelateField = ['department_id', 'site_id', 'customer_id', 'asset_type_id', 'asset_group_id'];
    let originalExpiryDate = '';

    objRequestFields.forEach( strField => {
      if (arRelateField.indexOf(strField) > -1) {
        if (this.data['recurring_job'][strField] == '') {
          this.data['recurring_job'][strField] = null;
        }
      }

      if (strField == 'expiry_date') {
        if (this.data['recurring_job'][strField] == '') {
          this.data['recurring_job'][strField] = null;
        } else {
          originalExpiryDate = objRequestData[strField];
        }
      }

      if (typeof this.data['recurring_job'][strField] == 'string' && typeof objRequestData[strField] == 'string') {
        if (this.data['recurring_job'][strField] != objRequestData[strField]) {
          if (strField == 'expiry_date') {
            objRequestData[strField] = originalExpiryDate;
          }
          this.bHasChanged = true;
        }
      } else {
        if (JSON.stringify(this.data['recurring_job'][strField]) != JSON.stringify(objRequestData[strField])) {
          this.bHasChanged = true;
        }
      }
    });
  }

  /**
   * Checks if selected checklists are their prompts are not empty
   *
   * @param {array} arChecklistData - Checklists which we would like to link in the job
   * @return {boolean}
   */
  isValidChecklistField(): boolean {
    // Variable if one of the checklist in line items has an empty prompts
    let hasChecklistError = false;

    this.arLineAttributes.forEach( (line_item, attr_index) => {
      if (this.arrService.keyFallsBackTo(line_item, 'checklist', null) !== null) {
        // This is for identifying which line items
        // has a checklist error
        let hasCurrentLineItemError = false;

        line_item['checklist'].forEach( checklist => {
          let promptIndex;
          let arPrompts;

          try {
            arPrompts = JSON.parse(checklist['questions']);
          } catch (e){
            return;
          }

          if (checklist['type'] === 'asset') {
            promptIndex = arPrompts.findIndex(item => (item.name == 'per_asset_prompts'));
          } else {
            promptIndex = arPrompts.findIndex(item => (item.name == 'main_prompts'));
          }

          if (promptIndex < 0 || arPrompts[promptIndex]['prompts'].length === 0) {
            hasCurrentLineItemError = true;
          }
        });

        if (hasCurrentLineItemError) {
          hasChecklistError = true;
          this.arLineAttributes[attr_index]['has_checklist_error'] = true;
        } else {
          this.arLineAttributes[attr_index]['has_checklist_error'] = false;
        }
      }
    });

    if (hasChecklistError) {
      this.notifService.notifyWarning('empty_checklist_prompt', {
        header: 'not_allowed',
      });

      this.bSubmitted = false;

      return false;
    }

    return true;
  }

  /**
   * Removes the line item.
   * @param attr - the object to be removed.
   */
  removeAttribute(i) {
    this.arLineAttributes.splice(i, 1);
    this.setDialogStyle();
  }

  addLineAttribute(objData: LooseObject = {}, strReferenceWorkOrder: string = null) {
    // Generate a unique name for the lineitem.
    let hasData = Object.keys(objData).length > 0;
    let intExistingWorkOrderIndex = this.arLineAttributes.findIndex(arLineAttr => arLineAttr['work_order_reference'] === strReferenceWorkOrder);
    let bLineItemExist = (strReferenceWorkOrder) ? intExistingWorkOrderIndex !== -1 : false;
    // If the generated name is indeed unique (no existing item of a similar name found.).
    if (!bLineItemExist) {
        if (Object.keys(objData).length > 0) {
          let items = get(objData, 'item', []);
          let expectedDuration = !isNil(objData['estimated_duration']) ? objData['estimated_duration'] : 0;
          let selectedItem = filled(get(objData, 'item_id', null)) ? items.find(item => item.id == objData['item_id']) : {};
          let updateData = {
            'asset_type_id' : objData['asset_type_id'],
            'asset_group_id' : objData['asset_group_id'],
            'department_id' : objData['department_id'],
            'user_id': objData['user_id'],
            'checklist_ids' : objData['checklist_ids'],
            'task_description' : objData['task_description'] ,
            'expected_hours' : !isNil(objData['expected_hours']) ? objData['expected_hours'] : expectedDuration,
            'estimated_hours' : !isNil(objData['estimated_hours']) ? objData['estimated_hours'] : 1,
            'estimated_materials' : !isNil(objData['estimated_materials']) ? objData['estimated_materials'] : 1,
            'team_id': objData['team_id'],
            'item_id': get(objData, 'item_id', null),
            'cost_estimation': get(objData, 'cost_estimation', null),
          };

          this.arLineAttributes.push({
            work_order_reference : objData['work_order_reference'] ? objData['work_order_reference'] : strReferenceWorkOrder,
            data: new RecurringJobLineItem(updateData),
            asset_type_obv: new Observable<Select[]>(),
            asset_type_typehead: new Subject<string>(),
            asset_type_loader: false,
            checklist_obv: new Observable<Select[]>(),
            checklist_typehead: new Subject<string>(),
            checklist_loader: false,
            asset_group_obv: new Observable<Select[]>(),
            asset_group_typehead: new Subject<string>(),
            asset_group_loader: false,
            department_obv: new Observable<Select[]>(),
            department_typehead: new Subject<string>(),
            department_loader: false,
            user_obv: new Observable<Select[]>(),
            user_typehead: new Subject<string>(),
            user_loader: false,
            team_obv: new Observable<Select[]>(),
            team_typehead: new Subject<string>(),
            team_loader: false,
            checklist: objData['checklist'],
            checklist_filter: {'is_checklist_enabled': true, 'checklists.asset_type_id': objData['asset_type_id']},
            has_checklist_error: false,
            item_obv: new Observable<Select[]>(),
            item_typehead: new Subject<string>(),
            item_loader: false,
            item: selectedItem,
          });
        } else {
          this.arLineAttributes.push({
            work_order_reference: objData['work_order_reference'] ? objData['work_order_reference'] : strReferenceWorkOrder,
            data: new RecurringJobLineItem(),
            asset_type_obv: new Observable<Select[]>(),
            asset_type_typehead: new Subject<string>(),
            asset_type_loader: false,
            checklist_obv: new Observable<Select[]>(),
            checklist_typehead: new Subject<string>(),
            checklist_loader: false,
            asset_group_obv: new Observable<Select[]>(),
            asset_group_typehead: new Subject<string>(),
            asset_group_loader: false,
            department_obv: new Observable<Select[]>(),
            department_typehead: new Subject<string>(),
            department_loader: false,
            user_obv: new Observable<Select[]>(),
            user_typehead: new Subject<string>(),
            user_loader: false,
            team_obv: new Observable<Select[]>(),
            team_typehead: new Subject<string>(),
            team_loader: false,
            checklist: null,
            checklist_filter: {},
            has_checklist_error: false,
            item_obv: new Observable<Select[]>(),
            item_typehead: new Subject<string>(),
            item_loader: false,
            item: {},
          });
        }
        this.arToggleJobTask.push({
          hidden: true
        });
    }

    // For User Relate
    this.setRelateField('users', 'user', null, (hasData) ? objData['user'] : []);
    // For Asset type Relate
    this.setRelateField('asset_types', 'asset_type', null, (hasData) ? objData['asset_type'] : []);
    // For Checklist Relate
    this.setRelateField('checklists', 'checklist', null, (hasData) ? objData['checklist'] : []);
    // For Asset Group Relate
    this.setRelateField('asset_groups', 'asset_group', null, (hasData) ? objData['asset_group'] : []);
    // For Department Relate
    this.setRelateField('departments', 'department', null, (hasData) ? objData['department'] : []);
    // For Team Relate
    this.setRelateField('teams', 'team', null, (hasData) ? objData['team'] : []);
    this.setRelateField('items', 'item', null, (hasData) ? objData['item'] : []);

    this.setDialogStyle();
  }

  addAssetAttribute(objData: LooseObject = {}, strReferenceWorkOrder: string = null) {
    let hasData = Object.keys(objData).length > 0;

        if (Object.keys(objData).length > 0) {

          let updateData = {
            'asset_type_id' : objData['asset_type_id'],
            'asset_tags_id' : objData['asset_tags_id'],
            'department_id' : objData['department_id'],
            'price_per_asset': objData['price_per_asset'],
            'checklist_ids' : objData['checklist_ids'],
            'time_per_asset' : objData['time_per_asset'],
          };

          this.arLineAttributes.push({
            data: new AssetItems(updateData),
            asset_type_obv: new Observable<Select[]>(),
            asset_type_typehead: new Subject<string>(),
            asset_type_loader: false,
            checklist_obv: new Observable<Select[]>(),
            checklist_typehead: new Subject<string>(),
            checklist_loader: false,
            asset_tags_obv: new Observable<Select[]>(),
            asset_tags_typehead: new Subject<string>(),
            asset_tags_loader: false,
            asset_tags: objData['asset_tags'],
            department_obv: new Observable<Select[]>(),
            department_typehead: new Subject<string>(),
            department_loader: false,
            checklist: objData['checklist'],
            checklist_filter: {'is_checklist_enabled': true, 'checklists.asset_type_id': objData['asset_type_id']},
            has_checklist_error: false,
            price_per_asset_obv: new Observable<number>(),
            price_per_asset_typehead: new Subject<number>(),
            price_per_asset_loader: false,
            price_per_asset: objData['price_per_asset'],
            time_per_asset_obv: new Observable<string>(),
            time_per_asset_typehead: new Subject<string>(),
            time_per_asset_loader: false,
            time_per_asset: objData['time_per_asset']
          });
        } else {
          this.arLineAttributes.push({
            data: new AssetItems(),
            asset_type_obv: new Observable<Select[]>(),
            asset_type_typehead: new Subject<string>(),
            asset_type_loader: false,
            checklist_obv: new Observable<Select[]>(),
            checklist_typehead: new Subject<string>(),
            checklist_loader: false,
            asset_tags_obv: new Observable<Select[]>(),
            asset_tags_typehead: new Subject<string>(),
            asset_tags_loader: false,
            department_obv: new Observable<Select[]>(),
            department_typehead: new Subject<string>(),
            department_loader: false,
            checklist: null,
            checklist_filter: {},
            has_checklist_error: false,
            price_per_asset_obv: new Observable<number>(),
            price_per_asset_typehead: new Subject<number>(),
            price_per_asset_loader: false,
            time_per_asset_obv: new Observable<string>(),
            time_per_asset_typehead: new Subject<string>(),
            time_per_asset_loader: false,
          });
    }

    // For Asset type Relate
    this.setRelateField('asset_types', 'asset_type', null, (hasData) ? objData['asset_type'] : []);
    // For Checklist Relate
    this.setRelateField('checklists', 'checklist', null, (hasData) ? objData['checklist'] : []);
    // For Asset Tags Relate
    this.setRelateField('tags', 'asset_tags', null, (hasData) ? objData['asset_tags'] : []);
    // For Department Relate
    this.setRelateField('departments', 'department', null, (hasData) ? objData['department'] : []);
    this.setDialogStyle();
  }


  /**
   * Remove a certain asset
   */
  removeAssetAttribute(index: number): void {
      if (this.arLineAttributes.length > 1) {
        this.arLineAttributes.splice(index, 1);
      }
  }
  /**
   * Initialize relate fields
   * @param strObservableName - observable that is set
   * @param strModule - module for relate
   * @param objMainFilter - Main filter for record (onChange of the fields)
   * @param arRelateInitialValue - Initial relate value
   */
  setRelateField(strModule, strObservableName, objMainFilter, arRelateInitialValue: object | [] = [], curentIndex: number | string = '') {
    // Get the lastest index.
    let index = (curentIndex === '') ? this.arLineAttributes.length - 1 : curentIndex;
    let strObservable = strObservableName + '_obv';
    let strTypehead = strObservableName + '_typehead';
    let strLoader = strObservableName + '_loader';
    let bHasAdditionalFilter: boolean = strModule !== 'asset_types';
    // Set a default dropdown value for this line item.
    this.arLineAttributes[index][strObservable] = concat(
      of(arRelateInitialValue),
      this.arLineAttributes[index][strTypehead].pipe(
        debounceTime(400),
        distinctUntilChanged(),
        tap(() => this.arLineAttributes[index][strLoader] = true),
        switchMap((term) => {
          let filter = {};

          if (filled(data_get(this.arLineAttributes[index], 'checklist_filter'))) {
            filter = {
              ... filter,
              ... fallback(data_get(this.arLineAttributes[index], 'checklist_filter'), {
                fallback: () => ({}),
              }),
            };
          }

          if (strModule == 'checklists') {
            filter = {
              ... filter,
              'type': ['asset', 'job'],
            };
          }

          return this.recordService.getRecordRelate(strModule, term, '', false, filter, 10, bHasAdditionalFilter).pipe(
            tap(() => {
              this.arLineAttributes[index][strLoader] = false;
            })
          );
        })
      )
    )
  }

  /**
   * Initialize relate field
   * @param {string} strModule - module to get related data
   * @param strObservableName - Observable name i.e department
   * @param strIndex - Index of attribute
   * @param objFilter - Desired Filter
   */
  getRelatedData(strModule, strObservableName, strIndex, objFilter: any = false) {
    let strLoader = strObservableName + '_loader';
    let bHasAdditionalFilter: boolean = strModule !== 'asset_types';

    // FC-4660: Add tags to assets module
    if (strModule == 'tags') {
      objFilter = {'module': 'assets'};
    } else if (strModule == 'checklists') {
      objFilter = fallback(objFilter, {
        fallback: () => ({}),
      });

      objFilter = {
        ... objFilter,
        'type': ['job', 'asset'],
      };
    }

    this.arLineAttributes[strIndex][strLoader] = true;
    this.recordService.getRecordRelate(strModule, '', false, false, objFilter, 10, bHasAdditionalFilter).subscribe( result => {

      this.setRelateField(strModule, strObservableName, objFilter, result, strIndex);
      this.arLineAttributes[strIndex][strLoader] = false;
    });

    this.setDialogStyle();
  }

  /**
   * When asset type is change
   * Add the value of selected id
   * to the current line item
   * checklist filter
   *
   * @param value
   * @param index
   */
  assetTypeChange(value, index) {
    if (value !== undefined && value.id) {
      this.arLineAttributes[index]['checklist_filter'] = {'is_checklist_enabled': true, 'checklists.asset_type_id': value.id}
    } else {
      this.arLineAttributes[index]['checklist_filter'] = {}
    }
  }

  /**
   * Get index of form
   * @param strField
   */
  getFormFieldIndex(strField) {
    return this.recurringJobForm.findIndex(attr => (attr.groups.get(strField) != undefined && attr.groups.get(strField) != null));
  }

  /**
   * Get index of field
   * @param strField
   * @param form
   */
  getFieldIndex(strField, form) {
    if (form != undefined && form['fields'] != undefined) {
      return form['fields'].findIndex( attr => (attr['key'] == strField));
    } else {
      return -1;
    }
  }

  /**
   * Set value of field
   * @param strField
   * @param strValue
   */
  fieldPatchValue(strField, strValue) {
    let indexOfFormField = this.getFormFieldIndex(strField);
    if (indexOfFormField > -1) {
      this.recurringJobForm[indexOfFormField]['groups'].patchValue({
        [strField] : strValue,
      }, {emitEvent: false, onlySelf: true});
    }
  }

  /**
   * When checklist field is change
   * get all ids and set it to data
   * checklist ids in line items
   *
   * @param value
   * @param attr_index
   */
  checklistChange(value, attr_index) {
    if (value !== undefined) {
      let ids = [];
      value.forEach( data => {
        ids.push(data['id']);
      });

      this.arLineAttributes[attr_index]['data']['checklist_ids'] = ids;
    }

    this.isValidChecklistField();
  }

  tagsChange(value, attr_index) {
      let ids = [];
      value.forEach( data => {
        ids.push(data['id']);
      });

      this.arLineAttributes[attr_index]['data']['asset_tags_id'] = ids;
  }

  /**
   * Validate Request
   * @param objRequest
   */
  validateRequest(objRequest) {
    this.wasValidated$.next(false);

    if (data_is_false(data_get(objRequest, 'billable'))) {
      this.arRequiredField = this.arRequiredField.filter(strField => strField !== 'invoicing_type');
    }

    for (let key in objRequest) {
      if (this.arRequiredField.indexOf(key) > -1 && key != 'assets_items') {
        if((objRequest[key] == undefined || objRequest[key] == '' || objRequest[key] == null || objRequest[key].length < 1)) {
          let indexOfFormField = this.getFormFieldIndex(key);

          if (indexOfFormField > -1) {
            this.recurringJobForm[indexOfFormField]['groups']['controls'][key].markAsTouched();
            this.recurringJobForm[indexOfFormField]['groups']['controls'][key].setErrors({'incorrect' : true});
          }

          if (!this.bDepartmentTracking && key != 'department_id') {
            this.hasError = true;
          }

        }
      }
    }

    if (! isValidWorkOrderLines(this._workOrderLines, this.bDepartmentTracking)) {
      this.hasError = true;
    }

    if (this.hasError) {
      this.wasValidated$.next(true);
    }
  }

  /**
   * This is to increase the row
   * when textarea is focus
   */
  increaseRow(i) {
    let currentElem = document.querySelector('.task-desc-'+ i);
    currentElem.setAttribute("style", "height: 100px");
  }

  /**
   * This is to decrease the row
   * when textarea is focus out
   */
  decreaseRow(i) {
    let currentElem = document.querySelector('.task-desc-'+ i);
    currentElem.setAttribute("style", "height: 40px");
  }

  /*
   * Mark field as dirty
   *
   * @param {string} field
   *
   * @returns {void}
   */
  markFormControlDirty(field: string): void {
    this.recurringJobForm.controls[field].markAsDirty();
  }

  /**
   * Set style for dialog to avoid
   * the dropdown panel to be behind
   * in the dialog content
   */
  setDialogStyle(): void {
    let dialogParentElement = document.getElementsByClassName('cdk-global-overlay-wrapper');
    let dialogElement = document.getElementsByClassName('mat-dialog-container');
    let currentWindowHeight = window.innerHeight;

    if (dialogParentElement.length > 0 && dialogElement.length > 0) {
      // We need to set overflow on dialog parent element. So
      // when dialog is more than the dialog parent it will
      // be scrollable
      this.renderer.setStyle(dialogParentElement[0], 'overflow', 'auto');
      let heightOfAdditionalLineItems = 81;
      // Check the dialog height to current window height.
      // to set the correct overflow in the dialog
      if ((dialogElement[0].getBoundingClientRect().height + heightOfAdditionalLineItems) > currentWindowHeight) {
        dialogElement[0].setAttribute("style", "overflow: auto !important");
      } else {
        dialogElement[0].setAttribute("style", "overflow: visible !important");
      }
    }
  }

  /**
   * Listens to form error
   *
   * @returns {void}
   */
  onFormError(): void {
    this.disabledSaveButton$.next(true);
  }

  /**
   * Before we save the recurring job.
   * We need to emit a value to child component
   * to process the work order items.
   */
  preSaveRecurringJob() {
    // FC-4023: check if recurring job's 'Schedule Automatically' field is set to true as there is further logic to be performed if it is true.
    let bScheduleAutomatically: boolean = this.isRecurringJobAutoschedule();
    // If schedule automatically is set to true, and job tasks tab is not empty, display prompt if technician field in job tasks is empty.
    if (bScheduleAutomatically && this.noAssignedUser()) {
      this.notifService.sendConfirmation('recurring_job_no_technician')
        .pipe(
          filter(confirmation => confirmation.answer === true)
        )
        .subscribe(() => {
          this.saveRecurringJob();
        });
    } else {
      this.saveRecurringJob();
    }
  }

  /**
   * Gets the value of the 'Schedule Automatically' field located at the 'System' tab of the form.
   *
   * @return {boolean}
   */
  isRecurringJobAutoschedule(): boolean {
    // FC-4023: If 'Schedule Automatically' field is set to true, and the job tasks tab is not empty,
    // should display a prompt to user if there are job tasks with no selected Technician,
    // and the prompt should say that if the technician field is empty, that job task will
    // be set to Awaiting Scheduling.
    //
    // Get the system form group first as the 'Schedule Automatically' field is located there.
    let objSystemFormGroup: { fields: Form[], groups: FormGroup } = this.recurringJobForm.find(objGroup => get(objGroup, 'id', '') === 'schedule');
    let objSchedAutomaticallyField: FormControl;

    if (objSystemFormGroup) {
      // get the schedule_automatically field
      objSchedAutomaticallyField = objSystemFormGroup.groups.get('schedule_automatically') as FormControl;
    }

    if (objSchedAutomaticallyField) {
      // return the value of the schedule automatically field
      return get(objSchedAutomaticallyField, 'value', false);
    }

    return false;
  }

  /**
   * Checks the 'Job Tasks' section of the recurring job form if there are any tasks without an assigned technician.
   * Only applies if the 'Job Tasks' section is not blank.
   *
   * @return {boolean}
   */
  hasJobTasksWithoutTechnician(): boolean {
    const isTaskDataEmpty = (objTaskData: RecurringJobLineItem) => {
      return isEmpty(objTaskData.asset_group_id) &&
        isEmpty(objTaskData.asset_type_id) &&
        isEmpty(objTaskData.checklist_ids) &&
        isEmpty(objTaskData.department_id) &&
        isEmpty(objTaskData.user_id) &&
        isEmpty(trim(objTaskData.task_description));
    };

    for (let row of this.arLineAttributes) {
      let objTaskData: RecurringJobLineItem = row['data'];

      // to check if job tasks tab is empty, check first if the length of arLineAttributes is just 1,
      // and then check if the objTaskData attributes are all empty.
      if (this.arLineAttributes.length === 1 && isTaskDataEmpty(objTaskData)) {
        return false;
      }

      // if job tasks tab is not empty, find the first instance of a job task with no technician and return true
      if (isEmpty(get(objTaskData, 'user_id'))) {
        return true;
      }
    }

    return false;
  }

  noAssignedUser(): boolean {
    let userFormIndex = this.getFormFieldIndex('user_id');
    let userIndexField = this.getFieldIndex('user_id', this.recurringJobForm[userFormIndex]);

    return isEmpty(this.recurringJobForm[userFormIndex]['fields'][userIndexField]['default_value']);
  }

  onMaterialsUpdate(event: OnMaterialsUpdate): void {
    this._materialLines = event.materials;
  }

  onWorkOrderUpdate(event: OnWorkOrderLinesUpdate): void {
    this._workOrderLines = event.work_order_items;
    this._pricebokId = event.pricebook_id;

    if (blank(event.work_order_items) || event.mode != 'add' || event.work_order_item.isGroup()) {
      return;
    }

    const line = event.work_order_item;
    const [isInMaterials, isInTasks] = this._isInTasksOrMaterials(line);

    if (isInMaterials || isInTasks || blank(get(line, 'item_id'))) {
      return;
    }

    if (! get(line, 'labor', true)) {
      const materials: MaterialLineData[] = _map(this._materialLines, (material) => material.getMaterialData());

      materials.push({
        unit_cost: get(line, 'unit_cost'),
        unit_price: whenFilled(get(line, 'discounted_price'), {
          then: () => get(line, 'discounted_price'),
          else: () => get(line, 'unit_price'),
        }),
        quantity: get(line, 'quantity'),
        work_order_reference: get(line, 'work_order_reference'),
        description: get(line, 'description'),
        from_work_order: true,
        item_id: get(line, 'item_id'),
        item_name: get(line, 'item_name'),
        item_code: get(line, 'item_code'),
        markup: get(line, 'markup'),
      });

      this.initialMaterials$.next(materials);
    } else {
      this.addLineAttribute({
        task_description: get(line, 'description'),
        estimated_duration: 1,
        department: whenFilled(get(line, 'department'), {
          then: () => _first(get(line, 'department')),
          else: () => [],
        }),
        department_id: whenFilled(get(line, 'department'), {
          then: () => get(first(get(line, 'department')), 'id'),
        }),
        from_work_order: true,
        work_order_reference: get(line, 'work_order_reference'),
        expected_hours: this.arrService.keyFallsBackTo(line, 'expected_hours', 0),
        estimated_hours: this.arrService.keyFallsBackTo(line, 'estimated_hours', 0),
        estimated_materials: this.arrService.keyFallsBackTo(line, 'estimated_materials', 0),
      }, get(line, 'work_order_reference'));
    }
  }

  private _isInTasksOrMaterials(line: WorkOrderLine): [boolean, boolean] {
    const isInMaterials = isIn(this._materialLines, {
      comparator: (material) => material.work_order_reference == get(line, 'work_order_reference'),
    });

    const isInTasks = isIn(this.arLineAttributes, {
      comparator: (task) => get(task, 'work_order_reference') == get(line, 'work_order_reference'),
    });

    return [isInMaterials, isInTasks];
  }

  /**
   * on change field
   *
   * @param event
   * @param field
   */
  onChangeFormField(event: any, field: string) {
    if (field == 'invoicing_type') {
      this.currentInvoicing = event;
    }
    if (field == 'billable') {
      this.isBillableOn = event.checked
    }
    if (field == 'resource_id') {
      if (filled(get(event, 'data.skill_id'))) {
        let newSkillIdValue = event.data.skill_id;
        const skillIdValue = this.getFormFieldValue('skill_id');

        if (filled(skillIdValue)) {
          const skillIdSet = new Set();
          newSkillIdValue = skillIdValue
            .concat(event.data.skill_id)
            .filter(({ id }) => !skillIdSet.has(id) && skillIdSet.add(id));
        }

        this.fieldPatchValue('skill_id', newSkillIdValue);
      }
    }

    this.updateBillingTabDisplay();
  }

  updateBillingTabDisplay(): void {
    // FC-4660: Rename Work Order to Billing. Billing tab should only
    // appear if invoicing type is flexible invoicing or fixed price
    let billingFormIndex = this.getFormFieldIndex('work_order_items');
    let invoicingTypeForBilling = ['flexible_invoicing', 'fixed_price_invoices'];
    let otherInvoicingType = ['per_asset_billing', 'time_and_materials'];

    let strInvoicingType: string|null = null;
    const informationGroup = this.recurringJobForm.find(group => get(group, 'label') === 'information');

    if (filled(informationGroup)) {
      strInvoicingType = get(informationGroup, 'groups.value.invoicing_type', null) || null;
    }

    const isInvoiceForBilling = invoicingTypeForBilling.includes(strInvoicingType) ||
            invoicingTypeForBilling.includes(this.currentInvoicing['id']);

    const isInvoiceNotForBilling = otherInvoicingType.includes(strInvoicingType) ||
            otherInvoicingType.includes(this.currentInvoicing['id']);

    const addBillingTab = this.isBillableOn && isInvoiceForBilling;
    const removeBillingTab = ((!this.isBillableOn && billingFormIndex > -1) ||
                              (billingFormIndex > -1 && isInvoiceNotForBilling)) && !addBillingTab;

    if (addBillingTab && billingFormIndex == -1) {
      this.recurringJobForm.splice(1, 0, this.objWorkOrder);
    }

    if (removeBillingTab) {
      this.objWorkOrder = this.recurringJobForm[billingFormIndex];
      this.recurringJobForm.splice(billingFormIndex, 1);
    }
  }

   getFormFieldValue(strField: string): any {
    let intFormFieldIndex = this.getFormFieldIndex(strField);
    if (intFormFieldIndex > -1) {
      if (filled(this.recurringJobForm[intFormFieldIndex]['groups'])) {
        return get(
          this.recurringJobForm[intFormFieldIndex]['groups'],
          `controls.${strField}.value`
        )
      }
    }
    return null
  }

  private _toggleInvoicingTypeDisplay(bValue: boolean): void {
    // FC-4660: Replaced Amount field to Invoicing Type, appearing when billable is true
    let invoicingTypeFormIndex = this.getFormFieldIndex('invoicing_type');
    let invoicingTypeIndexField = this.getFieldIndex('invoicing_type', this.recurringJobForm[invoicingTypeFormIndex]);

    if (bValue) {
      this.recurringJobForm[invoicingTypeFormIndex]['fields'][invoicingTypeIndexField]['is_hidden'] = false;
    } else {
      this.recurringJobForm[invoicingTypeFormIndex]['fields'][invoicingTypeIndexField]['is_hidden'] = true;
    }
  }
}
